/* רכיב הנגשה עצמאי (Accessibility Widget) — עברית / RTL */
(function () {
"use strict";
if (window.__a11yWidgetLoaded) return;
window.__a11yWidgetLoaded = true;
var CONFIG = {
position: "right",
accent: "#0a66c2",
statementUrl: "/pages/accessibility",
contactEmail: "",
fontStep: 10,
fontMax: 60,
fontMin: -30
};
var STORE_KEY = "a11y-widget-state";
var defaultState = {
font: 0, highContrast: false, invert: false, grayscale: false,
links: false, headings: false, readableFont: false,
lineSpacing: 0, letterSpacing: 0, bigCursor: false, stopAnim: false,
align: "", readingGuide: false, readingMask: false, keyboardNav: false
};
var state = loadState();
function loadState() {
    try {
    var s = JSON.parse(localStorage.getItem(STORE_KEY));
    if (s && typeof s === "object") return Object.assign({}, defaultState, s);
    } catch (e) {}
    return Object.assign({}, defaultState);
    }
    function saveState() {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {}
    }
    function injectCSS() {
    var css = ''
    + ':root{--a11y-accent:' + CONFIG.accent + ';}'
    + '.a11y-fab{position:fixed;bottom:20px;' + CONFIG.position + ':20px;z-index:2147483000;width:56px;height:56px;border-radius:50%;background:var(--a11y-accent);border:none;cursor:pointer;box-shadow:0 4px 14px rgba(0,0,0,.25);display:flex;align-items:center;justify-content:center;transition:transform .15s;}'
    + '.a11y-fab:hover{transform:scale(1.08);}'
    + '.a11y-fab:focus-visible{outline:3px solid #fff;outline-offset:2px;}'
    + '.a11y-fab svg{width:32px;height:32px;fill:#fff;}'
    + '.a11y-panel{position:fixed;bottom:88px;' + CONFIG.position + ':20px;z-index:2147483000;width:320px;max-width:calc(100vw - 40px);max-height:calc(100vh - 120px);overflow-y:auto;background:#fff;color:#1a1a1a;border-radius:14px;box-shadow:0 8px 40px rgba(0,0,0,.3);direction:rtl;font-family:Arial,sans-serif;display:none;padding:16px;}'
    + '.a11y-panel.open{display:block;}'
    + '.a11y-panel *{box-sizing:border-box;}'
    + '.a11y-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:12px;}'
    + '.a11y-head h2{font-size:18px;margin:0;color:#111;font-weight:700;}'
    + '.a11y-close{background:none;border:none;font-size:24px;line-height:1;cursor:pointer;color:#555;padding:4px 8px;border-radius:6px;}'
    + '.a11y-close:hover{background:#eee;}'
    + '.a11y-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px;}'
    + '.a11y-btn{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;padding:12px 6px;border:2px solid #e2e2e2;border-radius:10px;background:#fafafa;color:#222;font-size:13px;font-weight:600;cursor:pointer;text-align:center;min-height:64px;transition:all .12s;}'
    + '.a11y-btn:hover{border-color:var(--a11y-accent);background:#f0f6fc;}'
    + '.a11y-btn:focus-visible{outline:3px solid var(--a11y-accent);outline-offset:2px;}'
    + '.a11y-btn.active{border-color:var(--a11y-accent);background:var(--a11y-accent);color:#fff;}'
    + '.a11y-btn .a11y-ico{font-size:20px;line-height:1;}'
    + '.a11y-reset{grid-column:span 2;background:#fff0f0;border-color:#f3c2c2;color:#b00;}'
    + '.a11y-reset:hover{background:#ffe0e0;border-color:#e08080;}'
    + '.a11y-foot{margin-top:12px;padding-top:10px;border-top:1px solid #eee;font-size:12px;color:#555;text-align:center;}'
    + '.a11y-foot a{color:var(--a11y-accent);text-decoration:underline;}'
    + 'html.a11y-invert{filter:invert(1) hue-rotate(180deg);background:#fff;}'
    + 'html.a11y-invert img,html.a11y-invert video,html.a11y-invert picture{filter:invert(1) hue-rotate(180deg);}'
    + 'html.a11y-grayscale{filter:grayscale(100%);}'
    + 'html.a11y-invert.a11y-grayscale{filter:invert(1) hue-rotate(180deg) grayscale(100%);}'
    + 'html.a11y-contrast body,html.a11y-contrast body *{background:#000 !important;color:#ff0 !important;border-color:#ff0 !important;}'
    + 'html.a11y-contrast a,html.a11y-contrast a *{color:#0ff !important;}'
    + 'html.a11y-links a{text-decoration:underline !important;outline:1px dashed currentColor;outline-offset:2px;}'
    + 'html.a11y-headings h1,html.a11y-headings h2,html.a11y-headings h3,html.a11y-headings h4,html.a11y-headings h5,html.a11y-headings h6{outline:2px dashed var(--a11y-accent) !important;outline-offset:3px;background:rgba(10,102,194,.06);}'
    + 'html.a11y-readable body,html.a11y-readable body *:not(.a11y-panel):not(.a11y-fab){font-family:Arial,sans-serif !important;}'
    + 'html.a11y-stopanim *,html.a11y-stopanim *::before,html.a11y-stopanim *::after{animation:none !important;transition:none !important;scroll-behavior:auto !important;}'
    + 'html.a11y-bigcursor,html.a11y-bigcursor *{cursor:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2748%27 height=%2748%27 viewBox=%270 0 48 48%27%3E%3Cpath d=%27M8 4l30 18-14 3-6 14z%27 fill=%27black%27 stroke=%27white%27 stroke-width=%272%27/%3E%3C/svg%3E") 4 4,auto !important;}'
    + 'html.a11y-keyboardnav a:focus,html.a11y-keyboardnav button:focus,html.a11y-keyboardnav input:focus,html.a11y-keyboardnav select:focus,html.a11y-keyboardnav textarea:focus,html.a11y-keyboardnav [tabindex]:focus{outline:3px solid #ff6b00 !important;outline-offset:2px !important;}'
    + '.a11y-guide{position:fixed;left:0;right:0;height:0;border-top:3px solid var(--a11y-accent);box-shadow:0 0 6px rgba(0,0,0,.4);z-index:2147482000;pointer-events:none;display:none;}'
    + '.a11y-guide.on{display:block;}'
    + '.a11y-mask{position:fixed;left:0;right:0;height:120px;z-index:2147481000;pointer-events:none;display:none;box-shadow:0 0 0 9999px rgba(0,0,0,.55);}'
    + '.a11y-mask.on{display:block;}';
    var style = document.createElement("style");
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
    }
    var els = {};
    function buildUI() {
    var fab = document.createElement("button");
    fab.className = "a11y-fab";
    fab.setAttribute("aria-label", "פתיחת תפריט נגישות");
    fab.setAttribute("aria-haspopup", "true");
    fab.setAttribute("aria-expanded", "false");
    fab.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm9 6c0 .55-.45 1-1 1-1.66.12-3.32.2-4.99.24l.72 4.32 1.62 6.48c.14.53-.18 1.08-.71 1.22-.53.14-1.08-.18-1.22-.71L14 16h-4l-1.42 4.85c-.14.53-.69.85-1.22.71-.53-.14-.85-.69-.71-1.22l1.62-6.48.72-4.32C7.32 9.2 5.66 9.12 4 9c-.55 0-1-.45-1-1s.45-1 1-1c2.66.2 5.33.3 8 .3s5.34-.1 8-.3c.55 0 1 .45 1 1z"/></svg>';
    fab.addEventListener("click", togglePanel);
    document.body.appendChild(fab);
    els.fab = fab;
    var panel = document.createElement("div");
    panel.className = "a11y-panel";
    panel.setAttribute("role", "dialog");
    panel.setAttribute("aria-label", "תפריט נגישות");
    var foot = "";
    var footLinks = [];
    if (CONFIG.statementUrl) footLinks.push('<a href="' + CONFIG.statementUrl + '">הצהרת נגישות</a>');
    if (CONFIG.contactEmail) footLinks.push('<a href="mailto:' + CONFIG.contactEmail + '">פנייה בנושא נגישות</a>');
    if (footLinks.length) foot = '<div class="a11y-foot">' + footLinks.join(" · ") + '</div>';
    panel.innerHTML =
    '<div class="a11y-head"><h2>תפריט נגישות</h2>'
    + '<button class="a11y-close" aria-label="סגירת תפריט נגישות">×</button></div>'
    + '<div class="a11y-grid">'
    + btn("font-inc", "🔍", "הגדל טקסט")
    + btn("font-dec", "🔎", "הקטן טקסט")
    + btn("contrast", "◐", "ניגודיות גבוהה")
    + btn("invert", "🌓", "ניגודיות הפוכה")
    + btn("grayscale", "⚫", "גווני אפור")
    + btn("links", "🔗", "הדגשת קישורים")
    + btn("headings", "🅷", "הדגשת כותרות")
    + btn("readable", "🔤", "פונט קריא")
    + btn("line", "↕", "ריווח שורות")
    + btn("letter", "↔", "ריווח אותיות")
    + btn("align", "▤", "יישור טקסט")
    + btn("cursor", "🖱", "סמן גדול")
    + btn("stopanim", "⏸", "עצירת הבהובים")
    + btn("keyboardnav", "⌨", "ניווט מקלדת")
    + btn("guide", "―", "מדריך קריאה")
    + btn("mask", "▬", "מסכת קריאה")
    + '<button class="a11y-btn a11y-reset" data-act="reset">↺ איפוס</button></div>'
    + foot;
    document.body.appendChild(panel);
    els.panel = panel;
    panel.querySelector(".a11y-close").addEventListener("click", closePanel);
    panel.querySelectorAll(".a11y-btn").forEach(function (b) {
    b.addEventListener("click", function () { handleAction(b.getAttribute("data-act")); });
    });
    var guide = document.createElement("div");
    guide.className = "a11y-guide";
    document.body.appendChild(guide);
    els.guide = guide;
    var mask = document.createElement("div");
    mask.className = "a11y-mask";
    document.body.appendChild(mask);
    els.mask = mask;
    document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && panel.classList.contains("open")) closePanel();
    });
    document.addEventListener("mousemove", function (e) {
    if (state.readingGuide) guide.style.top = e.clientY + "px";
    if (state.readingMask) mask.style.top = (e.clientY - 60) + "px";
    });
    }
    function btn(act, ico, label) {
    return '<button class="a11y-btn" data-act="' + act + '" aria-pressed="false"><span class="a11y-ico" aria-hidden="true">' + ico + '</span><span>' + label + '</span></button>';
    }
    function togglePanel() {
    if (els.panel.classList.contains("open")) closePanel(); else openPanel();
    }
    function openPanel() {
    els.panel.classList.add("open");
    els.fab.setAttribute("aria-expanded", "true");
    els.panel.querySelector(".a11y-close").focus();
    }
    function closePanel() {
    els.panel.classList.remove("open");
    els.fab.setAttribute("aria-expanded", "false");
    els.fab.focus();
    }
    function handleAction(act) {
        switch (act) {
        case "font-inc": state.font = Math.min(CONFIG.fontMax, state.font + CONFIG.fontStep); break;
        case "font-dec": state.font = Math.max(CONFIG.fontMin, state.font - CONFIG.fontStep); break;
        case "contrast": state.highContrast = !state.highContrast; if (state.highContrast) { state.invert = false; state.grayscale = false; } break;
        case "invert": state.invert = !state.invert; if (state.invert) state.highContrast = false; break;
        case "grayscale": state.grayscale = !state.grayscale; if (state.grayscale) state.highContrast = false; break;
        case "links": state.links = !state.links; break;
        case "headings": state.headings = !state.headings; break;
        case "readable": state.readableFont = !state.readableFont; break;
        case "line": state.lineSpacing = (state.lineSpacing + 1) % 4; break;
        case "letter": state.letterSpacing = (state.letterSpacing + 1) % 4; break;
        case "align": var order = ["", "right", "center", "left"]; state.align = order[(order.indexOf(state.align) + 1) % order.length]; break;
        case "cursor": state.bigCursor = !state.bigCursor; break;
        case "stopanim": state.stopAnim = !state.stopAnim; break;
        case "keyboardnav": state.keyboardNav = !state.keyboardNav; break;
        case "guide": state.readingGuide = !state.readingGuide; break;
        case "mask": state.readingMask = !state.readingMask; break;
        case "reset": state = Object.assign({}, defaultState); break;
        }
        saveState();
        apply();
        }
        function apply() {
        var html = document.documentElement;
        html.style.fontSize = state.font ? (100 + state.font) + "%" : "";
        if (state.lineSpacing) html.style.setProperty("line-height", [null, 1.6, 2.0, 2.5][state.lineSpacing], "important");
        else html.style.removeProperty("line-height");
        if (state.letterSpacing) html.style.setProperty("letter-spacing", [null, "1px", "2px", "3px"][state.letterSpacing], "important");
        else html.style.removeProperty("letter-spacing");
        if (state.align) html.style.setProperty("text-align", state.align, "important");
        else html.style.removeProperty("text-align");
        toggleClass(html, "a11y-contrast", state.highContrast);
        toggleClass(html, "a11y-invert", state.invert);
        toggleClass(html, "a11y-grayscale", state.grayscale);
        toggleClass(html, "a11y-links", state.links);
        toggleClass(html, "a11y-headings", state.headings);
        toggleClass(html, "a11y-readable", state.readableFont);
        toggleClass(html, "a11y-bigcursor", state.bigCursor);
        toggleClass(html, "a11y-stopanim", state.stopAnim);
        toggleClass(html, "a11y-keyboardnav", state.keyboardNav);
        els.guide.classList.toggle("on", state.readingGuide);
        els.mask.classList.toggle("on", state.readingMask);
        updateButtons();
        }
        function toggleClass(el, cls, on) { if (on) el.classList.add(cls); else el.classList.remove(cls); }
        function updateButtons() {
        var map = {
        "contrast": state.highContrast, "invert": state.invert, "grayscale": state.grayscale,
        "links": state.links, "headings": state.headings, "readable": state.readableFont,
        "cursor": state.bigCursor, "stopanim": state.stopAnim, "keyboardnav": state.keyboardNav,
        "guide": state.readingGuide, "mask": state.readingMask,
        "line": state.lineSpacing > 0, "letter": state.letterSpacing > 0, "align": !!state.align,
        "font-inc": state.font > 0, "font-dec": state.font < 0
        };
        els.panel.querySelectorAll(".a11y-btn").forEach(function (b) {
        var act = b.getAttribute("data-act");
        if (act in map) { var on = !!map[act]; b.classList.toggle("active", on); b.setAttribute("aria-pressed", on ? "true" : "false"); }
        });
        }
        function init() { injectCSS(); buildUI(); apply(); }
        if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
        else init();
        })();